(function () {
  function setupInstance(btn) {
    if (btn.dataset.loadMoreBound === 'true') return;
    btn.dataset.loadMoreBound = 'true';
    const gridId = btn.getAttribute('data-grid-id') || 'product-grid';
    const grid = document.getElementById(gridId) || document.querySelector('#' + CSS.escape(gridId)) || document.querySelector('#product-grid');
    if (!grid) return;

    const spinner = btn.querySelector('.loadmore-spinner');
    const label = btn.querySelector('.loadmore-text');

    async function loadNextPage(url) {
      btn.disabled = true;
      if (spinner) spinner.hidden = false;
      if (label) label.textContent = 'Loading…';

      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Network error');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Always try the main collection grid in the fetched page
        const nextGrid = doc.querySelector('#product-grid') || doc.querySelector('.embed-product-grid');
        if (nextGrid) {
          Array.from(nextGrid.children).forEach(el => grid.appendChild(el));
        }

        const nextBtn = doc.querySelector('[data-loadmore]');
        const nextUrl = nextBtn ? nextBtn.getAttribute('data-next-url') : null;

        if (nextUrl) {
          btn.setAttribute('data-next-url', nextUrl);
          btn.disabled = false;
          if (spinner) spinner.hidden = true;
          if (label) label.textContent = 'Load more';
          if ('replaceState' in history) history.replaceState({}, '', url);
        } else {
          if (spinner) spinner.hidden = true;
          if (label) label.textContent = 'No more products';
          btn.setAttribute('aria-disabled', 'true');
          btn.style.opacity = 0.6;
          // Stop auto observer if any
          try { btn.__io && btn.__io.disconnect && btn.__io.disconnect(); } catch(e){}
        }

        document.dispatchEvent(new CustomEvent('theme:section:reveal'));
      } catch (e) {
        console.error(e);
        if (spinner) spinner.hidden = true;
        if (label) label.textContent = 'Try again';
        btn.disabled = false;
      }
    }

    btn.addEventListener('click', () => {
      const url = btn.getAttribute('data-next-url');
      if (url) loadNextPage(url);
    });

    // Auto infinite scroll support (global flag or data attribute)
    if (window.__LOADMORE_AUTO__ || btn.hasAttribute('data-auto')) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && btn.getAttribute('data-next-url') && !btn.disabled) {
            btn.click();
          }
        });
      }, { rootMargin: '400px 0px' });
      io.observe(btn);
      btn.__io = io;
    }
  }

  function init() {
    const loadAll = !!window.__LOADMORE_LOADALL__;
    const buttons = document.querySelectorAll('[data-loadmore]');
    buttons.forEach(setupInstance);
    if (loadAll && !navigator.connection?.saveData) {
      // Auto-load all pages sequentially
      buttons.forEach((btn) => {
        const loop = () => {
          const next = btn.getAttribute('data-next-url');
          if (!next || btn.getAttribute('aria-disabled') === 'true') return;
          // Trigger one load, then queue the next after it completes
          const observer = new MutationObserver((mut) => {
            // Check if button text changed or aria-disabled set
            if (btn.getAttribute('aria-disabled') === 'true' || !btn.getAttribute('data-next-url')) {
              observer.disconnect();
              return; // finished
            }
            // When new nodes appended, attempt another click
            observer.disconnect();
            setTimeout(loop, 50);
          });
          observer.observe(document.querySelector('body'), { childList: true, subtree: true });
          btn.click();
        };
        loop();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();